<template>
  <nav v-if="totalPages > 1" data-theme="light" class="pagination" aria-labelledby="pagination">
    <div class="module-body">
      <h2 id="pagination" class="visuallyhidden">Pagination</h2>
      <ul class="type-p-3-semibold">
        <li>
          <a
              v-if="currentPage === 1"
              href="#"
              @click.prevent
              disabled
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 12" height="12" width="17"
                 aria-hidden="true">
              <path fill="currentColor"
                    d="M13.809 5.222 9.058 1.1l1.108-1.1 6.041 6-6.04 6-1.11-1.102 4.752-4.12H.207V5.222h13.602Z"/>
            </svg>
            <span>Previous</span>
          </a>
          <a
              v-else
              href="#"
              @click.prevent="goToPrevious"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 12" height="12" width="17"
                 aria-hidden="true">
              <path fill="currentColor"
                    d="M13.809 5.222 9.058 1.1l1.108-1.1 6.041 6-6.04 6-1.11-1.102 4.752-4.12H.207V5.222h13.602Z"/>
            </svg>
            <span>Previous</span>
          </a>
        </li>
        <!-- Render the pagination items -->
        <li v-for="(item, index) in pagesToShow" :key="index">
          <span v-if="item === 'ellipsis'" class="pagination-truncated">…</span>
          <a
              v-else
              href="#"
              @click.prevent="goToPage(item)"
              :aria-current="item === currentPage ? 'page' : null"
          >
            {{ item }}
          </a>
        </li>
        <li>
          <a
              v-if="currentPage === totalPages"
              href="#"
              @click.prevent
              disabled
          >
            <span>Next</span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 12" height="12" width="17"
                 aria-hidden="true">
              <path fill="currentColor"
                    d="M13.809 5.222 9.058 1.1l1.108-1.1 6.041 6-6.04 6-1.11-1.102 4.752-4.12H.207V5.222h13.602Z"/>
            </svg>
          </a>
          <a
              v-else
              href="#"
              @click.prevent="goToNext"
          >
            <span>Next</span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 12" height="12" width="17"
                 aria-hidden="true">
              <path fill="currentColor"
                    d="M13.809 5.222 9.058 1.1l1.108-1.1 6.041 6-6.04 6-1.11-1.102 4.752-4.12H.207V5.222h13.602Z"/>
            </svg>
          </a>
        </li>
      </ul>
    </div>
  </nav>
</template>
<script setup>
import {computed} from 'vue'

const props = defineProps({
  currentPage: {
    type: Number,
    required: true
  },
  totalPages: {
    type: Number,
    required: true
  }
})

const emit = defineEmits(['change-page'])

// Computed property to calculate which pages to show
const pagesToShow = computed(() => {
  const pages = []
  const current = props.currentPage
  const total = props.totalPages

  if (current <= 3)
  {
    // Pages 1-3: Show 1, 2, 3, 4, ..., last
    for (let i = 1; i <= Math.min(4, total); i++)
    {
      pages.push(i)
    }
    if (total > 4)
    {
      pages.push('ellipsis')
      pages.push(total)
    }
  }
  else
    if (current >= total - 2)
    {
      // Last 3 pages: Show 1, ..., n-3, n-2, n-1, n
      pages.push(1)
      if (total > 4)
      {
        pages.push('ellipsis')
      }
      for (let i = Math.max(total - 3, 2); i <= total; i++)
      {
        if (!pages.includes(i))
        {
          pages.push(i)
        }
      }
    }
    else
    {
      // Middle pages: Show 1, ..., current-1, current, current+1, ..., last
      pages.push(1)
      pages.push('ellipsis')
      pages.push(current - 1)
      pages.push(current)
      pages.push(current + 1)
      pages.push('ellipsis')
      pages.push(total)
    }

  return pages
})

// Methods to handle pagination
const goToPage = (page) => {
  if (page !== props.currentPage && page !== 'ellipsis')
  {
    emit('change-page', page)
  }
}

const goToPrevious = () => {
  if (props.currentPage > 1)
  {
    emit('change-page', props.currentPage - 1)
  }
  // Silently ignore if already on first page
}

const goToNext = () => {
  if (props.currentPage < props.totalPages)
  {
    emit('change-page', props.currentPage + 1)
  }
  // Silently ignore if already on last page
}
</script>
